import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/SlotConfiguration.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/recommendations/slots`;
	}
	list(e, t = {}) {
		return this.api.get(this.buildPath(n.baseUrl, {
			...t,
			trackingId: e
		}));
	}
	create(e) {
		return this.api.post(n.baseUrl, e);
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
	getSlotSettings(e) {
		return this.api.get(`${n.baseUrl}/${e}/settings`);
	}
	updateSlotSettings(e, t) {
		return this.api.put(`${n.baseUrl}/${e}/settings`, t);
	}
	getSlotStrategies(e) {
		return this.api.get(`${n.baseUrl}/${e}/strategies`);
	}
	getStrategies(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/strategies`, {
			slotType: e,
			seedType: t
		}));
	}
	listNames(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/names`, e));
	}
};
//#endregion
export { n as SlotConfiguration };

//# sourceMappingURL=SlotConfiguration.js.map